import qs from 'qs';
import request from '@/utils/request';

/* 消息通知 */
export function noticeListApi(params) {
  return request({
    url: `/query/message`,
    method: 'get',
    params
  })
}
/* 根据状态查询消息数量 */
export function noticeNumApi(params) {
  return request({
    url: `/query/message/count`,
    method: 'get',
    params
  })
}
/* 更新消息阅读状态 */
export function noticeUpdateApi(params) {
  return request({
    url: `/update/message/status`,
    method: 'post',
    headers: {'Content-Type': 'application/json;charset=UTF-8'},
    params
  })
}

/* 更新消息为已读 */
export function noticeUpdateRead(params) {
  return request({
    url: `/update/message/readStatus`,
    method: 'post',
    headers: {'Content-Type': 'application/json;charset=UTF-8'},
    data:params
  })
}

/* 更新消息为未读 */
export function noticeUpdateUnread(params) {
  return request({
    url: `/update/message/status0`,
    method: 'post',
    headers: {'Content-Type': 'application/json;charset=UTF-8'},
    data:params
  })
}

//删除消息
export function noticeDelete(params) {
  return request({
    url: `/delete/message/status`,
    method: 'post',
    headers: {'Content-Type': 'application/json;charset=UTF-8'},
    data:params
  })
}

// 站内信消息
export function getStationMsg(params){
  return request({
    url: `/query/messageInside`,
    method: 'get',
    params
  })
}
